import { useEffect, useState } from 'react'

import {
  clearStagedResubscriptionModal,
  peekStagedResubscriptionModal,
  type StagedResubscriptionModal,
} from '../helpers/resubscriptionModalHandoff'

/**
 * Takes the staged modal content for this mount and empties the hand-off. Call it above any early
 * return so the first mount consumes the content whether or not the content is rendered.
 */
export const useStagedResubscriptionModal = (): StagedResubscriptionModal | null => {
  const [staged] = useState(peekStagedResubscriptionModal)

  useEffect(() => {
    clearStagedResubscriptionModal()
  }, [])

  return staged
}
